import * as React from 'react';
import { browserHistory } from 'react-router';
import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux';
import { ThemeProvider } from 'styled-components';
import { theme } from './theme/theme';
import configureStore from './configureStore';
import Routes from './routes';
import { getProp, prop } from './utilities/';
// import { LanguageProvider } from '@bart.sk-eshop/react-i18n';
// import { loadTranslations } from './configureTrans';
import API from './services/API';
import { isEdge, browserVersion } from 'react-device-detect';
// import { FullscreenLoading } from './components/_helpers/FullscreenLoading/FullscreenLoading';
import { hydrate } from 'react-dom';
import { __ } from '@bart.sk-eshop/react-i18n';
import ErrorBoundary from './containers/Errors/ErrorBoundary';

declare global {
  interface Window {
    dataLayer: any;
    __INIT_DATA__: any;
    __REDUX_STATE__: any;
  }
}

// Defer Sentry initialization to improve initial load performance
if (typeof window !== 'undefined') {
  const setupPassiveListeners = () => {
    let passiveSupported = false;
    try {
      const options = {
        get passive() {
          passiveSupported = true;
          return false;
        },
      };
      window.addEventListener('test' as any, null as any, options as any);
      window.removeEventListener('test' as any, null as any);
    } catch (err) {
      passiveSupported = false;
    }

    if (passiveSupported) {
      const addEventListenerOriginal = EventTarget.prototype.addEventListener;
      (EventTarget.prototype.addEventListener as any) = function (
        this: any,
        type: any,
        listener: any,
        options?: any,
      ) {
        const passiveEvents = [
          'touchstart',
          'touchmove',
          'wheel',
          'mousewheel',
        ];
        if (passiveEvents.includes(type) && typeof options !== 'object') {
          addEventListenerOriginal.call(this, type, listener, {
            passive: true,
          });
        } else {
          addEventListenerOriginal.call(this, type, listener, options);
        }
      };
    }
  };
  setupPassiveListeners();

  // Initialize Sentry after app has loaded - use requestIdleCallback for better performance
  const initSentry = () => {
    import('@sentry/react').then((Sentry) => {
      import('@sentry/tracing').then((Tracing) => {
        Sentry.init({
          dsn: process.env.REACT_APP_SENTRY,
          integrations: [new Tracing.Integrations.BrowserTracing()],
          tracesSampleRate: 0.1,
          debug: false,
          ignoreErrors: [/Can't find variable: gmo/],
        });
      });
    });
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(initSentry, { timeout: 3000 });
  } else {
    setTimeout(initSentry, 3000);
  }
}

API.setBaseUrl(process.env.REACT_APP_API_BASE_URL || '');

let store;
if (typeof window !== 'undefined') {
  const initialData = getProp(window, '__INIT_DATA__');
  if (!initialData || initialData === '{{INIT_DATA}}') {
    window.__INIT_DATA__ = {};
  }

  const reduxState = getProp(window, '__REDUX_STATE__');
  if (!reduxState || reduxState === '{{SSR_INITIAL_STATE}}') {
    window.__REDUX_STATE__ = {};
  }
  store = configureStore(window.__REDUX_STATE__);
  const historyObj = syncHistoryWithStore(browserHistory, store);

  // const loadTranslationsData = () => loadTranslations('');

  if (!(isEdge && browserVersion === '18')) {
    if (window.__REDUX_STATE__) {
      API.setToken(prop(window.__REDUX_STATE__, 'auth.token', undefined));
    }

    hydrate(
      <ThemeProvider theme={theme}>
        {/*<LanguageProvider*/}
        {/*  translations={window.__INIT_DATA__.translations}*/}
        {/*  loadCatalogues={loadTranslationsData}*/}
        {/*  loadingContainer={<FullscreenLoading />}*/}
        {/*>*/}
        <ErrorBoundary>
          <Provider store={store}>
            <Routes history={historyObj} />
          </Provider>
        </ErrorBoundary>
        {/*</LanguageProvider>*/}
      </ThemeProvider>,
      document.getElementById('root'),
    );
  }
}

export { store };
